<template>
  <div
    :class="['layout', _isMobile() ? 'mobile' : '']"
    :style="{
      'background-image': 'url(' + tenantConfig.json_homeBg.image + ')',
      'background-repeat': tenantConfig.json_homeBg.repeat,
      'background-color': tenantConfig.json_homeBg.color,
      'background-size': tenantConfig.json_homeBg.size,
    }"
  >
    <Header2 v-if="tenantConfig.headerType == 2" id="header"/>
    <Header3 v-else-if="tenantConfig.headerType == 3" id="header"/>
    <Header v-else id="header"/>
    <Banner v-if="showBanner"/>
    <div class="cms">
      <router-view />
    </div>
    <a-back-top />
    <Footer id="footer"/>
  </div>
</template>

<script>
import { mixinDevice } from "@/utils/mixin.js";
import Header from "@/components/header/Header";
import Header2 from "@/components/header/Header2";
import Header3 from "@/components/header/Header3";
import Banner from '@/components/header/Banner'
import Footer from "@/components/footer/Footer";
export default {
  name: "CmdLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Header2,
    Header3,
    Header3,
    Banner,
    Footer,
  },
  watch: {
    '$route'(to, from) {
      this.showBanner = to.path.endsWith('/cms/list')
    }
  },
  data() {
    return {
      tenantConfig: {},
      showBanner: false
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;    
    this.showBanner = this.$route.path.endsWith('/cms/list')
  },
};
</script>
<style>
a * {
  transition: all 0.1s ease;
}
</style>
<style lang="less" scoped>
.layout {
  background: #f2f6f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .cms {
    flex:1 1 auto;
    width: 100%;
    max-width: 1200px;
    margin: 20px auto 20px;
    padding: 20px;
    background: #ffffffd1;
    border-radius: 30px;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
  #header,#footer{
    flex: 0 0 auto;
  }
}
.mobile{
  .cms{
    padding: 0px;
  }
}
</style>